import { fetchWrapper, objectToQueryParams } from '../utils';

export class admin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/payments';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async update(form) {
    return await fetchWrapper.patch(this.baseUrl, form);
  }

  static async downloadItem(paymentId) {
    const url = `${this.baseUrl}/download/${paymentId}`;
    return await fetchWrapper.get(url);
  }

  static async download(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async createFee(form) {
    const url = `${this.baseUrl}/fees`;
    return await fetchWrapper.post(url, form);
  }

  static async findAPSFeesToPay(filters) {
    const url = `${this.baseUrl}/fees/aps?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }
}
